import React from "react";
import { MdOutlineAdd } from "react-icons/md";
import ButtonSpinner from "../Loader/ButtonSpinner";
import { cn } from "../ui-x";

type Props = {
  label?: string;
  className?: string;
  onClick?: (e?: any) => void;
  type?: "button" | "submit" | "reset" | undefined;
  icon?: string;
  toBlank?: boolean;
  disabled?: boolean;
  loading?: boolean;
};

/**
 * The filled primary — the reference's commit button, so it is orange by
 * default. `cn()` means a call site can demote it (e.g. to bg-brand-navy on a
 * screen that already spends its one orange elsewhere); the old template
 * concatenated classes, so an override's effect depended on Tailwind's output
 * order rather than on the call site.
 */
const Button = ({
  label,
  className,
  onClick,
  icon,
  type,
  disabled,
  loading,
}: Props) => {
  const onClickHandler = (e?: any) => {
    if (typeof onClick === "function") {
      e.preventDefault();
      onClick(e);
    }
  };

  const renderIcon = () => {
    if (icon === "add") {
      return <MdOutlineAdd className="h-4 w-4" />;
    }
    // Add more conditions for other icons if needed
    return null;
  };

  return (
    <button
      type={type}
      disabled={disabled}
      className={cn(
        "inline-flex h-9 items-center justify-center gap-2 whitespace-nowrap rounded-lg border border-transparent px-4 text-sm font-semibold transition-colors",
        "bg-brand-orange text-white hover:bg-brand-orange-600",
        "disabled:cursor-not-allowed disabled:bg-muted disabled:text-muted-foreground disabled:hover:bg-muted",
        className
      )}
      onClick={onClickHandler}
    >
      {label}
      {renderIcon()}
      {loading && <ButtonSpinner />}
    </button>
  );
};

export default Button;
